// @theme component
export const enum CategoryModificators {
    RoundCategory = 'fn-rounded',
    BannerCategory = 'fn-banner',
    JackpotCategory = 'fn-jackpot',
    TopTenCategory = 'fn-top-',
    LiveDataCategory = 'fn-live-data',
    GameWcReplacer = 'fn-game-replacer'
}
